import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

const PROMOTION_OVERVIEW_VIEW_FIELDS = `
	meta {
		latestScan
		months { year month }
		competitorCount competitorsWithDeals90 preferredCompetitorCount
		typicalDepth90 deepestPercentage deepestHotelId deepestDate
	}
	rows {
		hotelId hotelName main preferredTier share90 medianDepth90 deepestPercentage deepestDate
		monthly { year month dealNights totalNights tracked }
		nightly { statDate percentage dealName dealBookingFunded tracked available minimumStay }
		types { code name bookingFunded days }
	}
	excludedHotelNames
`;

export const FIND_PROMOTION_OVERVIEW_QUERY: GraphQL = {
	name: 'findPromotionOverview',
	gql: gql`
		query findPromotionOverview($companyHotelId: Long!, $filterInput: MarketStateFilterInput!) {
			findPromotionOverview(companyHotelId: $companyHotelId, filterInput: $filterInput) {
				hotelPaid { ${PROMOTION_OVERVIEW_VIEW_FIELDS} }
				withBookingFunded { ${PROMOTION_OVERVIEW_VIEW_FIELDS} }
			}
		}
	`,
};
